/* eslint-disable no-param-reassign */
/* eslint-disable import/prefer-default-export */
import axios from 'axios';
import { getNewTokenAsync } from '../../features/auth/redux/actions';
import { getUrls } from '../constants';
import { history } from '../history';

export const setupInterceptors = store => {
  axios.interceptors.request.use(config => {
    const { session } = store.getState();
    const token = session.access_token;

    // Fallback path: if the FE has a token in Redux (e.g. code-grant flow), continue attaching it.
    // Cookie-only path: access_token is null, so the browser sends the HttpOnly cookie instead.
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  }, error => Promise.reject(error));

  const skipRefreshUrls = [
    getUrls('prowl', 'verifypassword'),
    getUrls('prowl', 'refresh')
  ];

  axios.interceptors.response.use(response => response, async error => {
    const originalRequest = error.config;
    const isSkipRefreshUrl = originalRequest.url
      && skipRefreshUrls.some(u => originalRequest.url.includes(u));

    if (error.response && error.response.status === 401 && !originalRequest._retry && !originalRequest.headers['skip-refresh'] && !isSkipRefreshUrl) {
      originalRequest._retry = true;

      try {
        await store.dispatch(getNewTokenAsync());
        // Retry the original request with the new cookie
        return axios(originalRequest);
      } catch (refreshError) {
        // Refresh failed — already logged out by getNewTokenAsync
        return Promise.reject(error);
      }
    }

    const nonBlockingUrls = [
      getUrls('heartbeat', 'status').replace('{robotId}', ''),
      getUrls('hue', 'notifications'),
      'scripts/convert'
    ];
    // Auth-negotiation URLs are not user-facing; their failures are handled by the auth layer.
    const skipErrorUrls = [
      getUrls('prowl', 'refresh')
    ];
    const requestUrl = error.response?.config?.url ?? '';
    const isNonBlocking = nonBlockingUrls.some(u => requestUrl.includes(u));
    const skipError = skipErrorUrls.some(u => requestUrl.includes(u));

    const { session } = store.getState();

    if (error.response && error.response.status > 299
      && ![400, 401, 403, 404, 409].includes(error.response.status)
      && !isNonBlocking
      && !skipError
      && session.isAuthenticated) {
      history.push('/error');
      return Promise.reject(error);
    }

    return Promise.reject(error);
  });
};
